import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import React from 'react';
import { Box, xcss } from '@atlaskit/primitives';
var textStyles = xcss({
  // content can grow and shrink
  flexGrow: 1,
  flexShrink: 1,
  // ellipsis for overflow text
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap'
});
var iconStyles = xcss({
  display: 'flex',
  // icon size cannot grow and shrink
  flexGrow: 0,
  flexShrink: 0,
  alignSelf: 'center',
  fontSize: 0,
  lineHeight: 0,
  userSelect: 'none'
});
var commonStyles = xcss({
  transition: 'opacity 0.3s'
});
var fadeStyles = xcss({
  opacity: 0
});
/**
 * __Content__
 *
 * Used for slots within a Button, including icons and text content.
 */
var Content = function Content(_ref) {
  var children = _ref.children,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'text' : _ref$type,
    hasOverlay = _ref.hasOverlay;
  return /*#__PURE__*/React.createElement(Box, {
    as: "span",
    xcss: [commonStyles].concat(_toConsumableArray(type === 'text' ? [textStyles] : [iconStyles]), _toConsumableArray(hasOverlay ? [fadeStyles] : []))
  }, children);
};
export default Content;